import React, { useState } from 'react'
import styles from './DocsCreator.module.scss'
import delete_icon from './../../../UI/icons/constructor-edit/delete.svg'
import edit_icon from './../../../UI/icons/constructor-edit/edit.svg'
import upArrow_icon from './../../../UI/icons/constructor-edit/up.svg'
import downArrow_icon from './../../../UI/icons/constructor-edit/down.svg'
import { timeConverter } from '../../Online-schedule/components/functions'
import ActionBar from './component/ActionBar'
import Checkbox from '../../Global/Checkbox/Checkbox'
import PdfField from './component/PdfField/PdfField'
import TextareaMarkup from 'components/UI/TextareaMarkup/TextareaMarkup'
import FileSelector from 'components/UI/FileSelector/FileSelector'
import { SuperButton } from 'components/UI/SuperButton/SuperButton'
import { ReactComponent as LinkIcon } from 'components/UI/icons/constructor-edit/link.svg'
import Stores from 'Stores'

const DocsCreator = ({
  docsCreatorData,
  mode,
  setDocsCreatorData,
  getStopEditState,
}) => {
  const { hostname, protocol } = window.location

  const [isImgUploaded, setIsImgUploaded] = useState(false)

  const deleteElement = (key) => {
    let newState = { ...docsCreatorData }
    delete newState[key]
    setDocsCreatorData(newState)
  }

  const changeElementStatus = (element_key, e) => {
    e.stopPropagation()
    let newState = getStopEditState()
    newState[element_key].is_edit = !newState[element_key].is_edit
    setDocsCreatorData(newState)
  }

  const changeElementStyles = (element_key, value) => {
    let newState = { ...docsCreatorData }
    newState[element_key].styles = value
    setDocsCreatorData(newState)
  }

  const changeElementValue = (element_key, value) => {
    let newState = { ...docsCreatorData }
    newState[element_key].value = value
    setDocsCreatorData(newState)
  }

  const changeUserValue = (element_key, value) => {
    let newState = { ...docsCreatorData }
    newState[element_key].user_value = value
    setDocsCreatorData(newState)
  }

  const changeElementPosition = (element_key, way) => {
    let newState = { ...docsCreatorData }
    const thisEllement = { ...newState[element_key] }
    switch (way) {
      case 'up':
        if (newState[Number(element_key) - 1]) {
          const prevEllement = { ...newState[Number(element_key) - 1] }
          newState[element_key] = prevEllement
          newState[Number(element_key) - 1] = thisEllement
        }
        break
      case 'down':
        if (newState[Number(element_key) + 1]) {
          const nextEllement = { ...newState[Number(element_key) + 1] }
          newState[element_key] = nextEllement
          newState[Number(element_key) + 1] = thisEllement
        }
        break

      default:
        break
    }

    setDocsCreatorData(newState)
  }

  const listCreator = (row) => {
    let array = row.split('\n')
    return array
  }

  const JSXCreator = (elementData, element_key) => {
    let element
    let baseActionList = [
      {
        action(element_key, e) {
          deleteElement(element_key, e)
        },
        icon: delete_icon,
      },
      {
        action(element_key, e) {
          e.stopPropagation()
          changeElementPosition(element_key, 'down')
        },
        icon: downArrow_icon,
      },
      {
        action(element_key, e) {
          e.stopPropagation()
          changeElementPosition(element_key, 'up')
        },
        icon: upArrow_icon,
      },
    ]

    let actionsList = [
      {
        action(element_key, e) {
          changeElementStatus(element_key, e)
        },
        icon: edit_icon,
      },
      ...baseActionList,
    ]

    let actionsListNonEdit = [...baseActionList]

    switch (elementData.type) {
      case 'text':
        element =
          mode === 'edit' ? (
            <div
              className={`${styles.element__box} ${styles.element__text}`}
              onClick={(e) => changeElementStatus(element_key, e)}
            >
              <div className={elementData.is_edit ? styles.display_none : ''}>
                <div className={styles.element__wrapperElements}>
                  <div
                    className={styles.element__text}
                    dangerouslySetInnerHTML={{
                      __html: (
                        elementData.value || elementData.placeholder
                      ).replace(/\n/g, '<br>'),
                    }}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              </div>

              {elementData.is_edit && (
                <div className={styles.editor}>
                  <TextareaMarkup
                    value={elementData.value || elementData.placeholder}
                    onChange={(newValue) =>
                      changeElementValue(element_key, newValue)
                    }
                    stateName='text'
                    error={false}
                    onClick={(e) => changeElementStatus(element_key, e)}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              )}
            </div>
          ) : (
            <div
              className={`${styles.element__box_view} ${styles.element__text}`}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: elementData.value || elementData.placeholder,
                }}
              />
            </div>
          )
        break

      case 'text_input':
        element =
          mode === 'edit' ? (
            <div
              className={`${styles.element__box} ${styles.element__text}`}
              onClick={(e) => changeElementStatus(element_key, e)}
            >
              <div className={elementData.is_edit ? styles.display_none : ''}>
                <div className={styles.element__wrapperElements}>
                  <div className={`${styles.element__userForm__box}`}>
                    <div
                      className={styles.element__userForm__text}
                      dangerouslySetInnerHTML={{
                        __html: elementData.value || elementData.placeholder,
                      }}
                    />
                    <input
                      className={styles.element__userForm__input}
                      onClick={(e) => {
                        e.stopPropagation()
                      }}
                      placeholder='Текст пользователя'
                      type='text'
                    />
                  </div>
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              </div>

              {elementData.is_edit && (
                <div className={styles.editor}>
                  <TextareaMarkup
                    value={elementData.value || elementData.placeholder}
                    onChange={(newValue) =>
                      changeElementValue(element_key, newValue)
                    }
                    stateName='text'
                    error={false}
                    onClick={(e) => changeElementStatus(element_key, e)}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              )}
            </div>
          ) : (
            <div
              className={`${styles.element__box_view} ${styles.element__text}`}
            >
              <div className={`${styles.element__userForm__box}`}>
                <p>{elementData.value || elementData.placeholder}</p>
                <input
                  className={styles.element__userForm__input}
                  value={elementData.user_value}
                  onClick={(e) => {
                    e.stopPropagation()
                  }}
                  onChange={(e) => changeUserValue(element_key, e.target.value)}
                  placeholder='Введите текст'
                  type='text'
                />
              </div>
            </div>
          )
        break

      case 'title_h1':
        element =
          mode === 'edit' ? (
            <div
              className={`${styles.element__box}`}
              onClick={(e) => changeElementStatus(element_key, e)}
            >
              <div className={elementData.is_edit ? styles.display_none : ''}>
                <div className={styles.element__wrapperElements}>
                  <h1
                    className={styles.element__title_h1}
                    dangerouslySetInnerHTML={{
                      __html: elementData.value || elementData.placeholder,
                    }}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              </div>
              {elementData.is_edit && (
                <div className={styles.editor}>
                  <TextareaMarkup
                    value={elementData.value || elementData.placeholder}
                    onChange={(newValue) =>
                      changeElementValue(element_key, newValue)
                    }
                    stateName='title_h1'
                    maxLength={100}
                    error={false}
                    onClick={(e) => changeElementStatus(element_key, e)}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className={`${styles.element__box_view}`}>
              <h1
                className={styles.element__title_h1}
                dangerouslySetInnerHTML={{
                  __html: elementData.value || elementData.placeholder,
                }}
              />
            </div>
          )
        break

      case 'title_h2':
        element =
          mode === 'edit' ? (
            <div
              className={`${styles.element__box}`}
              onClick={(e) => changeElementStatus(element_key, e)}
            >
              <div className={elementData.is_edit ? styles.display_none : ''}>
                <div className={styles.element__wrapperElements}>
                  <h2
                    className={styles.element__title_h2}
                    dangerouslySetInnerHTML={{
                      __html: elementData.value || elementData.placeholder,
                    }}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              </div>

              {elementData.is_edit && (
                <div className={styles.editor}>
                  <TextareaMarkup
                    value={elementData.value || elementData.placeholder}
                    onChange={(newValue) =>
                      changeElementValue(element_key, newValue)
                    }
                    stateName='title_h2'
                    maxLength={100}
                    error={false}
                    onClick={(e) => changeElementStatus(element_key, e)}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className={`${styles.element__box_view}`}>
              <h2
                className={styles.element__title_h2}
                dangerouslySetInnerHTML={{
                  __html: elementData.value || elementData.placeholder,
                }}
              />
            </div>
          )
        break

      case 'title_h3':
        element =
          mode === 'edit' ? (
            <div
              className={`${styles.element__box}`}
              onClick={(e) => changeElementStatus(element_key, e)}
            >
              <div className={elementData.is_edit ? styles.display_none : ''}>
                <div className={styles.element__wrapperElements}>
                  <h3
                    className={styles.element__title_h3}
                    dangerouslySetInnerHTML={{
                      __html: elementData.value || elementData.placeholder,
                    }}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              </div>

              {elementData.is_edit && (
                <div className={styles.editor}>
                  <TextareaMarkup
                    value={elementData.value || elementData.placeholder}
                    onChange={(newValue) =>
                      changeElementValue(element_key, newValue)
                    }
                    stateName='title_h3'
                    maxLength={100}
                    error={false}
                    onClick={(e) => changeElementStatus(element_key, e)}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className={`${styles.element__box_view}`}>
              <h3
                className={styles.element__title_h3}
                dangerouslySetInnerHTML={{
                  __html: elementData.value || elementData.placeholder,
                }}
              />
            </div>
          )
        break

      case 'link':
        element =
          mode === 'edit' ? (
            <div className={`${styles.element__box}`}>
              <div className={elementData.is_edit ? styles.display_none : ''}>
                <div
                  className={
                    elementData.is_edit
                      ? styles.display_none
                      : styles.element__wrapper
                  }
                >
                  <div className={styles.element__wrapperElements}>
                    <a
                      target='_blank'
                      rel='noreferrer'
                      href={elementData.value.link}
                      className={styles.link}
                    >
                      <LinkIcon className={styles.link__icon} />
                      {elementData.value.text || elementData.value.placeholder}
                    </a>
                    <ActionBar
                      classes={styles.element__wrapper_icon}
                      element_key={element_key}
                      list={actionsList}
                    />
                  </div>
                </div>
              </div>

              {elementData.is_edit && (
                <div className={styles.editor}>
                  <form
                    className={
                      elementData.is_edit
                        ? styles.element__form
                        : styles.display_none
                    }
                    action=''
                  >
                    <input
                      className={styles.inputLink}
                      placeholder={elementData.placeholder}
                      value={elementData.value.text}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) =>
                        changeElementValue(element_key, {
                          ...elementData.value,
                          text: e.target.value,
                        })
                      }
                    />
                    <input
                      className={styles.inputLink}
                      placeholder={'Введите значение'}
                      value={elementData.value.link}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) =>
                        changeElementValue(element_key, {
                          ...elementData.value,
                          link: e.target.value,
                        })
                      }
                    />
                  </form>

                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className={`${styles.element__box_view}`}>
              <div className={elementData.is_edit ? styles.display_none : ''}>
                <a
                  target='_blank'
                  rel='noreferrer'
                  href={elementData.value.link}
                >
                  {`${elementData.value.text || elementData.placeholder}`}
                </a>
              </div>
            </div>
          )
        break

      case 'sign':
        element =
          mode === 'edit' ? (
            <div className={`${styles.element__box}`}>
              <div className={styles.element__wrapperElements}>
                <div className={styles.element__sign}>
                  <span
                    className={styles.element__sign_text}
                  >{`${elementData.value.text}`}</span>
                </div>
                <ActionBar
                  classes={styles.element__wrapper_icon}
                  element_key={element_key}
                  list={baseActionList}
                />
              </div>
            </div>
          ) : (
            <div className={`${styles.element__box_view}`}>
              <div className={styles.element__sign}>
                {`${elementData.value.text}`}
              </div>
            </div>
          )
        break

      case 'initials':
        element =
          mode === 'edit' ? (
            <div className={`${styles.element__box}`}>
              <div className={styles.element__wrapperElements}>
                <div className={styles.element__initials}>
                  {`${elementData.value.text}`}
                </div>
                <ActionBar
                  classes={styles.element__wrapper_icon}
                  element_key={element_key}
                  list={baseActionList}
                />
              </div>
            </div>
          ) : (
            <div className={`${styles.element__box_view}`}>
              <div className={styles.element__initials}>
                {`${elementData.value.text}`}
              </div>
            </div>
          )
        break

      case 'link_btn':
        element =
          mode === 'edit' ? (
            <div className={`${styles.element__box}`}>
              <div
                className={
                  elementData.is_edit
                    ? styles.display_none
                    : styles.element__wrapper_flex
                }
              >
                <div className={styles.element__wrapperElements}>
                  <a
                    target='_blank'
                    rel='noreferrer'
                    href={elementData.value.link}
                    className={styles.link_btn}
                  >
                    <SuperButton variant='confirm'>
                      {elementData.value.text || elementData.value.placeholder}
                    </SuperButton>
                  </a>
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsList}
                  />
                </div>
              </div>

              {elementData.is_edit && (
                <div className={styles.editor}>
                  <form
                    className={
                      elementData.is_edit
                        ? styles.element__form
                        : styles.display_none
                    }
                    action=''
                  >
                    <input
                      className={styles.inputLink}
                      placeholder={'Введите значение'}
                      value={elementData.value.text}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) =>
                        changeElementValue(element_key, {
                          ...elementData.value,
                          text: e.target.value,
                        })
                      }
                    />
                    <input
                      className={styles.inputLink}
                      placeholder={'Введите значение'}
                      value={elementData.value.link}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) =>
                        changeElementValue(element_key, {
                          ...elementData.value,
                          link: e.target.value,
                        })
                      }
                    />
                  </form>
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className={`${styles.element__box_view} `}>
              <div className={styles.element__wrapper_flex}>
                <a
                  target='_blank'
                  rel='noreferrer'
                  href={elementData.value.link}
                >
                  <button className={styles.button_link}>
                    {elementData.value.text || elementData.placeholder}
                  </button>
                </a>
              </div>
            </div>
          )

        break

      case 'listing_numbered':
        element =
          mode === 'edit' ? (
            <div
              className={`${styles.element__box}`}
              onClick={(e) => changeElementStatus(element_key, e)}
            >
              <div className={elementData.is_edit ? styles.display_none : ''}>
                <div className={styles.element__wrapperElements}>
                  <ol className={styles.element__listingNumbered_list}>
                    {listCreator(elementData.value).map((item, id) => (
                      <li
                        className={styles.element__listingNumbered_item}
                        key={id}
                      >
                        <b className={styles.element__listingNumbered_num}>
                          {id + 1}.&nbsp;
                        </b>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: item || elementData.placeholder,
                          }}
                        />
                      </li>
                    ))}
                  </ol>
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              </div>

              {elementData.is_edit && (
                <div className={styles.editor}>
                  <TextareaMarkup
                    value={elementData.value || elementData.placeholder}
                    onChange={(newValue) =>
                      changeElementValue(element_key, newValue)
                    }
                    stateName='listing_numbered'
                    error={false}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className={`${styles.element__box_view}`}>
              <ol className={styles.element__listingNumbered_list}>
                {listCreator(elementData.value).map((item, id) => (
                  <li className={styles.element__listingNumbered_item} key={id}>
                    <b className={styles.element__listingNumbered_num}>
                      {id + 1}.
                    </b>{' '}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: item,
                      }}
                    />
                  </li>
                ))}
              </ol>
            </div>
          )
        break

      case 'listing_marked':
        element =
          mode === 'edit' ? (
            <div
              className={`${styles.element__box}`}
              onClick={(e) => changeElementStatus(element_key, e)}
            >
              <div className={elementData.is_edit ? styles.display_none : ''}>
                <div className={styles.element__wrapperElements}>
                  <ul className={styles.element__listingMarked_list}>
                    {listCreator(elementData.value).map((item, id) => (
                      <li
                        className={styles.element__listingMarked_item}
                        key={id}
                        dangerouslySetInnerHTML={{
                          __html: item || elementData.placeholder,
                        }}
                      />
                    ))}
                  </ul>
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              </div>

              {elementData.is_edit && (
                <div className={styles.editor}>
                  <TextareaMarkup
                    value={elementData.value || elementData.placeholder}
                    onChange={(newValue) =>
                      changeElementValue(element_key, newValue)
                    }
                    stateName='listing_marked'
                    error={false}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className={`${styles.element__box_view}`}>
              <ul className={styles.element__listingMarked_list}>
                {listCreator(elementData.value).map((item, id) => (
                  <li className={styles.element__listingMarked_item} key={id}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          )

        break

      case 'checkbox_сonsent':
        element =
          mode === 'edit' ? (
            <div
              className={`${styles.element__box}`}
              onClick={(e) => changeElementStatus(element_key, e)}
            >
              <div className={elementData.is_edit ? styles.display_none : ''}>
                <div className={styles.element__wrapperElements}>
                  <Checkbox
                    name={element_key}
                    label={elementData.value || elementData.placeholder}
                    checked={true}
                    onChange={() => {}}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              </div>

              {elementData.is_edit && (
                <div className={styles.editor}>
                  <TextareaMarkup
                    mode='text'
                    value={elementData.value || elementData.placeholder}
                    onChange={(newValue) =>
                      changeElementValue(element_key, newValue)
                    }
                    stateName='text'
                    maxLength={100}
                    error={false}
                    onClick={(e) => e.stopPropagation()}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              )}
            </div>
          ) : (
            <div className={`${styles.element__box_view}`}>
              <div className={elementData.is_edit ? styles.display_none : ''}>
                <Checkbox
                  name={element_key}
                  label={elementData.value}
                  checked={
                    elementData.user_value ? elementData.user_value : false
                  }
                  onChange={(e) => {
                    changeUserValue(
                      element_key,
                      elementData.user_value ? !elementData.user_value : true,
                    )
                  }}
                />
              </div>
            </div>
          )
        break

      case 'checkbox_list':
        element =
          mode === 'edit' ? (
            <div className={`${styles.element__box}`}>
              <div
                onClick={(e) => changeElementStatus(element_key, e)}
                className={elementData.is_edit ? styles.display_none : ''}
              >
                <div className={styles.element__wrapperElements}>
                  <div
                    style={{
                      '--gridTemplateColumns': `${elementData.styles.grid_column}`,
                    }}
                    className={
                      elementData.is_edit
                        ? styles.display_none
                        : styles.element__checkBox_list
                    }
                  >
                    {elementData.value.map((checkBox, key) => (
                      <Checkbox
                        key={key}
                        name={`${element_key}${key}`}
                        label={checkBox.value || checkBox.placeholder}
                        checked={true}
                        onChange={() => {}}
                      />
                    ))}
                  </div>
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              </div>
              <div
                className={
                  elementData.is_edit
                    ? styles.element__form
                    : styles.display_none
                }
                onClick={(e) => e.stopPropagation()}
              >
                <TextareaMarkup
                  mode='checkbox_list'
                  value={elementData.value}
                  stateName={element_key}
                  onChange={(newData) =>
                    changeElementValue(element_key, newData)
                  }
                  onChangeGrid={(newGrid) =>
                    changeElementStyles(element_key, {
                      ...elementData.styles,
                      grid_column: newGrid,
                    })
                  }
                  className={styles.textareaMarkup}
                >
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </TextareaMarkup>
              </div>
            </div>
          ) : (
            <div
              onClick={(e) => {
                e.stopPropagation()
              }}
              className={`${styles.element__box_view}`}
            >
              <div
                style={{
                  '--gridTemplateColumns': `${elementData.styles.grid_column}`,
                }}
                className={
                  elementData.is_edit
                    ? styles.display_none
                    : styles.element__checkBox_list
                }
              >
                {elementData.value.map((checkBox, key) => {
                  const checkBoxKey = `${element_key}_${key}`
                  return (
                    <Checkbox
                      key={key}
                      name={checkBoxKey}
                      label={checkBox.value}
                      checked={
                        elementData.user_value
                          ? elementData.user_value[key]
                          : false
                      }
                      onChange={(e) => {
                        changeUserValue(
                          element_key,
                          elementData.user_value
                            ? {
                                ...elementData.user_value,
                                [key]: !elementData.user_value[key],
                              }
                            : { [key]: true },
                        )
                      }}
                    />
                  )
                })}
              </div>
            </div>
          )
        break

      case 'date':
        element =
          mode === 'edit' ? (
            <div className={`${styles.element__box}`}>
              <div className={styles.element__wrapperElements}>
                <span className={styles.element__date}>
                  {timeConverter(new Date(), 'dd.mm.yyyy')}
                </span>
                <ActionBar
                  classes={styles.element__wrapper_icon}
                  element_key={element_key}
                  list={baseActionList}
                />
              </div>
            </div>
          ) : (
            <div className={`${styles.element__box_view}`}>
              <div className={elementData.is_edit ? styles.display_none : ''}>
                {timeConverter(new Date(), 'dd.mm.yyyy')}
              </div>
            </div>
          )
        break

      case 'img':
        element =
          mode === 'edit' ? (
            <div className={styles.element__box}>
              <div className={styles.element__wrapperElements}>
                <FileSelector
                  constructor={true}
                  type='image'
                  iconType='edit'
                  types={['jpeg', 'jpg', 'png']}
                  value={''}
                  onChange={(val) => changeElementValue(element_key, val)}
                  onUploadStateChange={(isUploaded) =>
                    setIsImgUploaded(isUploaded)
                  }
                >
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </FileSelector>
                {!isImgUploaded && (
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                )}
              </div>
            </div>
          ) : (
            <div className={`${styles.element__box_view}`}>
              <img
                className={styles.element__img}
                src={
                  elementData.value
                    ? elementData.value.includes(
                        'https://phoenix.interpress.kz',
                      )
                      ? elementData.value.replace(
                          'https://phoenix.interpress.kz',
                          'https://api.phoenix.interpress.kz',
                        )
                      : elementData.value.startsWith('/media/')
                        ? `${Stores.baseLink()}${elementData.value}`
                        : elementData.value
                    : ''
                }
                alt='изображение'
              />
            </div>
          )
        break

      case 'pdf':
        element =
          mode === 'edit' ? (
            <div className={`${styles.element__box}`}>
              <div className={styles.element__wrapperElements}>
                <div className={styles.element__pdf_wrapper}>
                  <PdfField
                    showSize
                    onChange={(fileUrl, fileName) => {
                      const path = hostname.includes('localhost')
                        ? 'https://dev.phoenix24.io'
                        : `${protocol}//${hostname}`
                      changeElementValue(element_key, {
                        path: `${path}${fileUrl}`,
                        name: fileName,
                      })
                    }}
                  />
                </div>
                <ActionBar
                  classes={styles.element__wrapper_icon}
                  element_key={element_key}
                  list={actionsListNonEdit}
                />
              </div>
            </div>
          ) : (
            <div className={`${styles.element__box_view}`}>
              <div className={styles.element__pdf_wrapper}>
                <img
                  className={styles.element__pdf}
                  src={elementData.placeholder}
                  alt='изображение'
                />
                {elementData.value ? (
                  <a
                    target='_blank'
                    rel='noopener noreferrer'
                    href={`${elementData.value.path}`}
                  >
                    {elementData.value.name}
                  </a>
                ) : (
                  <div className=''>Выберите файл</div>
                )}
              </div>
            </div>
          )
        break

      case 'footer':
        element =
          mode === 'edit' ? (
            <div
              className={`${styles.element__box}`}
              onClick={(e) => changeElementStatus(element_key, e)}
            >
              <div className={elementData.is_edit ? styles.display_none : ''}>
                <div className={styles.element__wrapperElements}>
                  <div className={styles.element__footer_text}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: elementData.value || elementData.placeholder,
                      }}
                    />
                  </div>
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              </div>

              {elementData.is_edit && (
                <div className={styles.editor}>
                  <TextareaMarkup
                    value={elementData.value || elementData.placeholder}
                    onChange={(newValue) =>
                      changeElementValue(element_key, newValue)
                    }
                    stateName='text'
                    maxLength={100}
                    error={false}
                    onClick={(e) => changeElementStatus(element_key, e)}
                  />
                  <ActionBar
                    classes={styles.element__wrapper_icon}
                    element_key={element_key}
                    list={actionsListNonEdit}
                  />
                </div>
              )}
            </div>
          ) : (
            <div
              className={`${styles.element__box_view} ${styles.element__footer}`}
            ></div>
          )
        break

      default:
        break
    }
    return element
  }

  return (
    <>
      {Object.keys(docsCreatorData).map((key, i) => (
        <div key={i} className=''>
          {JSXCreator(docsCreatorData[key], key)}
        </div>
      ))}
    </>
  )
}

export default DocsCreator
